import React from 'react';
import {Currency, Text} from '@morningtrain/react-displays';
import {ModelContext} from '@morningtrain/react-resources';
import {CollectionContext, ForEachModel} from '@morningtrain/react-resources';
import {getMapValue} from "@morningtrain/react-helpers";
import Trans from 'app/components/trans/Trans';

export default class GroupOverview extends React.Component {

    static contextType = ModelContext;

    get customer()
    {
        const customer =  getMapValue(this.context, 'customer', null);

        if (!customer) return [];

        return Object.keys(customer)
            .filter(key => customer[key])
            .map((key) => ({
                label: key,
                value: customer[key],
            }));
    }

    render() {
        return (
            <div className={'section'}>
                <div className={'order-row'}>
                  <h1 className={'title'}><Trans>Ordregruppe</Trans>: <Text name={'group_number'}/></h1>
                </div>
                {/*<div className={'order-row no-border'}>*/}
                {/*    <span>*/}
                {/*        <b>Ordredato: </b><Text name={'date'}/>*/}
                {/*    </span>*/}
                {/*</div>*/}
                <div className={'order-row no-border'}>
                    <div className={'customer-details'}>
                        <div className={'name'}><Trans>Kunde</Trans></div>
                        <ul>
                            <CollectionContext.Provider value={this.customer}>
                                <ForEachModel>
                                    <li>
                                    <span>
                                        <b><Text name={'label'}/>: </b><Text name={'value'}/>
                                    </span>
                                    </li>
                                </ForEachModel>
                            </CollectionContext.Provider>
                        </ul>
                    </div>
                    <div className={'order-total'}>
                        <ul>
                            <li>
                                <span><Trans>Subtotal</Trans>:</span>
                                <p><Currency name={'prices.subtotal'}/></p>
                            </li>
                            <li>
                                <span><Trans>Levering</Trans>:</span>
                                <p><Currency name={'prices.delivery'}/></p>
                            </li>
                            <li>
                                <span><Trans>Gebyr</Trans>:</span>
                                <p><Currency name={'prices.fee'}/></p>
                            </li>
                            <li/>
                            <li>
                                <span><Trans>Rabat</Trans>:</span>
                                <p><Currency name={'prices.discount'}/></p>
                            </li>
                            <li>
                                <span><Trans>Gavekort</Trans>:</span>
                                <p><Currency name={'prices.giftcard'}/></p>
                            </li>
                            <li className={'total'}>
                                <span><Trans>Totalbeløb</Trans>:</span>
                                <p className={'price'}><Currency name={'prices.total'}/></p>
                            </li>
                            <li className={'remove-span-on-mobile'}>
                                <span/>
                                <p className={'tax'}>(<Trans>Moms udgør</Trans>: <Currency name={'prices.tax'}/>)</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}
